import React, { useState } from 'react';
import './Input.css';

function Input({
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  error,
  name,
  id,
  className = '',
  ...rest
}) {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword ? (showPassword ? 'text' : 'password') : type;
  const inputId = id || name;

  return (
    <div className={`input-group ${className}`}>
      {label && (
        <label className="input-label" htmlFor={inputId}>
          {label}
        </label>
      )}
      <div className="input-wrap">
        <input
          id={inputId}
          name={name}
          type={inputType}
          className={[
            'input-field',
            error ? 'input-field--error' : '',
            isPassword ? 'input-field--with-icon' : '',
          ]
            .filter(Boolean)
            .join(' ')}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          {...rest}
        />
        {isPassword && (
          <button
            type="button"
            className="input-icon-btn"
            aria-label={showPassword ? 'Hide password' : 'Show password'}
            onClick={() => setShowPassword((v) => !v)}
          >
            <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
          </button>
        )}
      </div>
      {error && <span className="input-error-msg">{error}</span>}
    </div>
  );
}

export default Input;
